
/// Map

const grayMapStyle = [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
    { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
    { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
    { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
    { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
    { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
    { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] }
];

export function nitgMapInit() {
    const center = positions.length > 0
        ? { lat: positions[0].lat, lng: positions[0].lng }
        : { lat: 53.4167, lng: 9.9167 };
    
    const map = new google.maps.Map(document.getElementById('map'), {
        center,
        zoom: 5,
        fullscreenControl: false,
        mapTypeControl: false,
        scrollwheel: true,
        signInControl: false,
        streetViewControl: false,
        styles: grayMapStyle
    });
    
    const infowindow = new google.maps.InfoWindow();
    
    positions.forEach((position) => {
        const marker = new google.maps.Marker({
            position,
            map,
            icon: {
                url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none">
			<path
				d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
				fill="#818181"
				stroke="#484848"
				stroke-width="1"
			/>
			<circle cx="12" cy="9" r="2.5" fill="#484848"/>
		</svg>
	`),
                scaledSize: new google.maps.Size(30, 40),
                anchor: new google.maps.Point(15, 40)
            }
        });
        const content = `${position.title}<br><b class="color-primary address">${position.address}</b>`;
        marker.addListener('click', () => {
            infowindow.setContent(content);
            infowindow.open(map, marker);
        });
    });
}